export default __webpack_public_path__ + "static/media/features1.4581706e.jpg";